// Copyright (c) 2022 by Move Closer.
import { AppModule, Container, IConfiguration, Interfaces, Module } from '@movecloser/front-core'

import { GraphQlConnectorType, GraphQLMiddleware, IGraphQL, ISiteService, SiteServiceType } from '../../contexts'

import { SiteGraphQLMiddleware, SiteGraphQLMiddlewareType } from './services'
import { storeFactory as state } from './store'
import { ISearchService, SearchServiceType } from '../shared/services/search'
import { COMPONENTS_STRUCTURE_CONFIG, logger } from '../../support'
import { latestResultConfig } from './config/search'
import { routesFactory as routes } from './routes'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
@AppModule({
  name: 'root',
  providers: () => (bind: Interfaces.Bind) => {
    bind<GraphQLMiddleware>(SiteGraphQLMiddlewareType).toDynamicValue((context) => {
      return new SiteGraphQLMiddleware(
        context.container.get<ISiteService>(SiteServiceType)
      )
    })
  },
  boot: (container: Container, config: IConfiguration) => {
    const graphQL = container.get<IGraphQL>(GraphQlConnectorType)
    graphQL.useMiddlewares(
      container.get(SiteGraphQLMiddlewareType)
    )

    // Register product search results config.
    const searchService = container.get<ISearchService | undefined>(SearchServiceType)
    if (searchService) {
      searchService.addTabs(latestResultConfig)
    } else {
      logger('[RootModule]: There\'s no SearchService available', 'debug')
    }
  },
  state,
  routes
})
export class RootModule extends Module {}
